import { useMemo } from "react";
import { Modal, FormField, Dropdown, Button } from "@common";
import { validatePctField, TYPE_OPTIONS } from "@utils/practitionerFormUtils";

export default function EditPractitionerModal({
  isOpen,
  onClose,
  onSave,
  formData,
  onInputChange,
  isPending = false,
}) {
  const feeMeta = useMemo(
    () => validatePctField(formData.associate_fee_percentage),
    [formData.associate_fee_percentage],
  );

  const feeInvalid = feeMeta.hasAny && !feeMeta.ok;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Practitioner" size="lg">
      <div className="space-y-4">
        <FormField
          label="Name"
          name="name"
          value={formData.name}
          onChange={(e) => onInputChange("name", e.target.value)}
          placeholder="Practitioner name"
        />

        <FormField
          label="Clinic"
          name="clinic"
          value={formData.clinic}
          onChange={(e) => onInputChange("clinic", e.target.value)}
          placeholder="Clinic code"
        />

        <Dropdown
          label="Practitioner Type"
          name="practitioner_type"
          value={formData.practitioner_type}
          onChange={(v) => onInputChange("practitioner_type", v)}
          // All 16 types from shared TYPE_OPTIONS; blank placeholder entry excluded for this modal's dropdown.
          options={TYPE_OPTIONS.filter((o) => o.value !== "")}
          placeholder="Select type"
        />

        <Dropdown
          label="Status"
          name="status"
          value={formData.status}
          onChange={(v) => onInputChange("status", v)}
          options={[
            { value: "active", label: "Active" },
            { value: "inactive", label: "Inactive" },
          ]}
          placeholder="Select status"
        />

        <FormField
          label="Associate Fee (%)"
          name="associate_fee_percentage"
          value={formData.associate_fee_percentage ?? ""}
          onChange={(e) => onInputChange("associate_fee_percentage", e.target.value)}
          placeholder="e.g. 40%"
          type="number"
          min={0}
          max={100}
          step="0.01"
          disabled={isPending}
          showError={false}
        />

        {feeInvalid && (
          <div className="mt-1 text-xs text-palette-red-badge">
            Associate fee percentage must be a valid number between 0 and 100.
          </div>
        )}

        <div className="flex items-center justify-between gap-4 mt-8 pt-4 border-t border-palette-gray-divider">
          <div className="flex-1"></div>
          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={isPending}
              className="border-palette-gray-border bg-white text-palette-gray-heading hover:bg-palette-gray-soft hover:border-palette-gray-placeholder"
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={onSave}
              disabled={isPending || feeInvalid}
              className="!bg-palette-blue-badge hover:!bg-palette-blue-heading"
            >
              {isPending ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
